import React from 'react';
import OpacityIcon from '@mui/icons-material/Opacity';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Irrigated" or "Dryland"' },
];

const IrrigationTypeManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Irrigation Types"
    icon={<OpacityIcon />}
    apiPath="/api/irrigation-types"
    fields={fields}
    entityLabel="Irrigation Type"
  />
);

export default IrrigationTypeManagement;
